module.exports = __webpack_public_path__ + "img/icon_pople_blue.2be638cb.png";